import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
//import { LoginService } from '../../services/login.service';
import { UserService } from 'src/app/services/users.service';
import { Message } from 'primeng/api';
import { passwordMatchValidator } from './password-match.validator';
import { MessageService } from 'primeng/api';

// Language
import { Subscription } from 'rxjs';
import { adminDictionary } from 'src/app/models/imadata/admin-diccionary';
import { LanguageService } from 'src/app/services/language.service';
import { STICKY_MESSAGE_SERVICE_PROVIDER } from 'src/app/services/sticky-message.service';

@Component({
  selector: 'app-validate_email',
  templateUrl: './validate_email.component.html',
  styleUrls: ['./validate_email.component.css'],
  providers: [STICKY_MESSAGE_SERVICE_PROVIDER]
})
export class ValidateEmailComponent implements OnInit{
  CL: string;
  private languageSubscription: Subscription;
  dict: any = {};

  logo: string = "assets/logos/imadata-logo.png";
  
  constructor(  
    public router: Router,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private userService: UserService,
    private messageService: MessageService
  ) {
    this.CL = this.languageService.getLanguage();
    this.dict = adminDictionary;
  }

  formGroup!: FormGroup;
  user_allowed: boolean = false;
  loading: boolean = true;

  validacion_completa: boolean = false;
  // Params url
  token: string = "";
  userId: string = "";

  async ngOnInit() {
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('redLink');
      localStorage.removeItem('api_token');
      localStorage.removeItem('rol_id');
      localStorage.removeItem('user_id');
      window.location.reload();
    }
    if (this.route.snapshot.queryParams) {
      let d = this.route.snapshot.queryParams['d'] ? this.route.snapshot.queryParams['d'] : null;
      if (d) {
        let da = atob(d).replace(/'/g, '"');
        let data = JSON.parse(da);
        this.token = data.token;
        this.userId = data.user;
      } else {
        this.token = null;
        this.userId = null;
      }
    }
    if (!this.token || !this.userId) {
      this.router.navigate(['/']);
    }
    this.languageSubscription = this.languageService.language$.subscribe(
      (language: string) => {
          this.CL = language;
          this.dict = adminDictionary;
      }
    );
    this.formGroup = new FormGroup({
      pass1: new FormControl('', Validators.required),
      pass2: new FormControl('', Validators.required)
    }, { validators: passwordMatchValidator });
    await Promise.all([
      this.checkValidUser()
    ]).then(() => {
      this.loading = false;
    });
  }
  checkValidUser(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.userService.checkUser(this.userId,this.token).subscribe((response: any) => {
        this.user_allowed = true;
        resolve();
      }, (error) => {
        this.router.navigate(['/']);
        reject();
      });
    });
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.sendValidation();
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Revise las contraseñas' });
    }
  }
  sendValidation() {
    let data = {
      user_id: this.userId,
      user_password: this.formGroup.value.pass1,
      rpt: this.token,
    }
    this.userService.validateEmail(data).subscribe((response: any) => {
      this.validacion_completa = true;
    },
    (error) => {
      // console.log('error', error);
      this.validacion_completa = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al validar el usuario' });
    });
  }
}